import { UnlockOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useState } from 'react';

export const BlockDeviceModalMobile = ({
  actualSegment,
  blockUnblockDevice,
  id,
  device_id,
  password,
  call_sign,
  army_post,
  type,
  tg,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    actualSegment === 'actual'
      ? blockUnblockDevice({ id, device_id, password, call_sign, army_post, type, tg }, '/api/device/block_device')
      : blockUnblockDevice({ id, device_id, password, call_sign, army_post, type, tg }, '/api/device/unblock_device');
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button
        type='default'
        onClick={showModal}
        icon={<UnlockOutlined />}
        size='small'
        style={{ width: '100%', position: 'relative' }}
        danger
      >
        {actualSegment === 'actual' ? 'Заблокировать' : 'Разблокировать'}
      </Button>
      <Modal
        title={`Информация об устройстве`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText='Отмена'
      >
        <p>{`Вы уверены что хотите ${actualSegment === 'actual' ? 'заблокировать' : 'разблокировать'} устройство ${
          device_id
        }`}</p>
      </Modal>
    </>
  );
};
